import { Typography, useTheme } from '@mui/material';
import React from 'react';
import { FadeLoader } from 'react-spinners';

import { useIsFullscreenLoaderVisible } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader.store';
import { LoaderOverlay } from '@/shared/components/ui/overlay-loader/overlay-loader.styled';
import { TOverLoaderProps } from '@/shared/components/ui/overlay-loader/overlay-loader.types';

export const OverlayLoader: React.FC<TOverLoaderProps> = ({
  display,
  hideLoader,
  squareTop,
  loaderText,
}) => {
  const theme = useTheme();
  const isFullscreenLoaderVisible = useIsFullscreenLoaderVisible();

  if (!display || isFullscreenLoaderVisible) {
    return null;
  }

  return (
    <LoaderOverlay
      $squareTop={squareTop}
      alignItems="center"
      justifyContent="center"
      gap="1rem"
    >
      {!hideLoader && <FadeLoader color={theme.palette.primary.main} />}
      {loaderText && (
        <Typography color="textSecondary">{loaderText}</Typography>
      )}
    </LoaderOverlay>
  );
};
